
    function stickyNav() {
    if($(window).width() >= 826){
     if (window.pageYOffset >= 125) {
        $(".navigation-container").addClass("sticky");
     } else {
        $(".navigation-container").removeClass("sticky");
     }
    }
    if($(window).width() <= 825){
        $(".navigation-container").removeClass("sticky");
    }  
   }
   function expandTab(event) {
        //tab expand and collapse for mobile navigation menu
        event. stopPropagation()
        if($( event.currentTarget).hasClass('active')){
            $( event.currentTarget).removeClass('active');
            window.scrollTo(0, 0);
        }
        else{
            $('.tab').removeClass('active');
            $('.list-header ').removeClass('active');
            $( event.currentTarget).addClass('active');
            // event.currentTarget.scrollIntoView({behavior: "smooth"});
        }
    }
    function expandTabLvl2(event) {
        //tab lvl2 expand and collapse for mobile navigation menu
        if($(window).width() <= 825){
            event. stopPropagation()
        }
        
        if($( event.currentTarget).hasClass('active')){
            $( event.currentTarget).removeClass('active');
            window.scrollTo(0, 0);
        }
        else{
            $('.list-header ').removeClass('active');
            $( event.currentTarget).addClass('active');
            // event.currentTarget.scrollIntoView({behavior: "smooth"});
        }
    }
    function preventClick(event){
        event.preventDefault();
    }
    function setDefaultMenu(event){
        $('.list-wrapper--activeMenu').removeClass('list-wrapper--activeMenu');
        $(event.currentTarget).find($( ".list-wrapper" )[ 0 ]).addClass('list-wrapper--defaultMenu');
      
    }
    function setActiveMenu(event){
        $('.list-wrapper--defaultMenu').removeClass('list-wrapper--defaultMenu');
        $('.list-wrapper--activeMenu').removeClass('list-wrapper--activeMenu');
        $(event.currentTarget).addClass('list-wrapper--activeMenu');
    }

$(document).ready(function() {
    //add service navigation to mobile menu
    var serviceNavigation = $('.service-navigation ul li').clone().get().reverse();
    $('.main-navigation2 > ul > .search-list').before(serviceNavigation);

    //show .list inside the first .list-wrapper by default
    $('.tab').hover(setDefaultMenu);
    //show .list on click
    $('.list-wrapper').click(setActiveMenu);

    //tab expand and collapse for mobile navigation menu
    $('.tab ').click(expandTab);
    $('.list-header').click(expandTabLvl2);
    
    //prevent click on nav tab that containes content
    $('.tab__content').parent(".tab").addClass('noclick');

    //navigation become sticky on scrolling
    $(window).scroll(stickyNav);

    
});
define("headerV2", function(){});

